export const delayTimeForVerifyEmailSuccessfulPage = {
  delayTime: 2000
};
